import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var autoExpandSelectionRangeOnInlineNodePluginKey = new PluginKey('autoExpandSelectionRangeOnInlineNodePlugin');